// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Wirder design tokens ───────────────────────────────────────
   Ported from the approved design system
   (.github/style/design-system.md). Single brand palette applied at
   :root. Imported globally from app.tsx. Fonts are loaded via a
   <link> in public/index.html.
   ────────────────────────────────────────────────────────────── */

:root {
  /* Primary (persimmon) */
  --palette-primary: #c8400c;
  --palette-primary-hover: #b23a0a;
  --palette-primary-active: #9a3208;
  --palette-on-primary: #ffffff;

  /* Secondary (royal blue, from the logo) */
  --palette-secondary: #0050c0;
  --palette-secondary-hover: #00429f;
  --palette-secondary-active: #003585;
  --palette-on-secondary: #ffffff;

  /* Accent (bright logo orange — decorative only, never text) */
  --palette-accent: #f05000;
  --palette-accent-soft: #fce6da;

  /* Surfaces (warm paper) */
  --palette-bg: #fbf7f0;
  --palette-surface: #ffffff;
  --palette-surface-alt: #f3ece0;
  --palette-surface-blue-soft: #e7edfa;

  /* Text (warm ink) */
  --palette-text: #1c1b1a;
  --palette-text-muted: #6b6357;

  /* Borders */
  --palette-border: #e4dccd;
  --palette-border-strong: #1c1b1a;

  /* Medal / rarity tiers (semantic, always paired with a label) */
  --medal-gold: #c9a227;
  --medal-silver: #9aa0a6;
  --medal-bronze: #a9744f;

  /* Type */
  --font-display: "Newsreader", Georgia, "Times New Roman", serif;
  --font-ui: "Inter", system-ui, -apple-system, "Segoe UI", sans-serif;

  /* Play-surface (board) font — switchable on the Settings screen. The active
     value is \`--font-board\`; it's remapped by the [data-board-font] attribute
     that DataLayer sets on <html>. Defaults to the classic display serif. */
  --font-board-serif: var(--font-display);
  --font-board-sans: "Calibri", "Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  --font-board: var(--font-board-serif);

  /* Radii */
  --r-btn: 12px;
  --r-tile: 12px;
  --r-card: 16px;

  /* Screen gutter */
  --pad: 20px;
}

/* Board-font override: DataLayer sets data-board-font on <html> from the saved
   preference (default is the serif above, so no attribute is needed for it). */
:root[data-board-font="sans"] {
  --font-board: var(--font-board-sans);
}

/* Global text-size override: DataLayer sets data-text-size on <html> from the
   saved preference. The app's text is sized in \`rem\`, so scaling the root
   font-size proportionally enlarges every text element — including the smallest
   labels (found-word chips, stat labels, captions). The board tiles are sized
   in px/cqh, so they stay fixed while the surrounding text grows. */
:root[data-text-size="default"] {
  font-size: 100%;
}
:root[data-text-size="large"] {
  font-size: 112.5%;
}
:root[data-text-size="larger"] {
  font-size: 125%;
}

body {
  margin: 0;
  font-family: var(--font-ui);
  background: var(--palette-bg);
  color: var(--palette-text);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

/* Type helpers */
.display {
  font-family: var(--font-display);
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.02;
}
.serif {
  font-family: var(--font-display);
}
.num {
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
}
.muted {
  color: var(--palette-text-muted);
}
.eyebrow {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--palette-text-muted);
}
.eyebrow--accent {
  color: var(--palette-primary);
}
`, "",{"version":3,"sources":["webpack://./src/styles/tokens.css"],"names":[],"mappings":"AAAA;;;;;mEAKmE;;AAEnE;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;;EAE7B,0CAA0C;EAC1C,4BAA4B;EAC5B,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;;EAE/B,8DAA8D;EAC9D,yBAAyB;EACzB,8BAA8B;;EAE9B,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;EAC1B,8BAA8B;EAC9B,oCAAoC;;EAEpC,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;;EAE7B,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;;EAEhC,gEAAgE;EAChE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;;EAEvB,SAAS;EACT,+DAA+D;EAC/D,oEAAoE;;EAEpE;;4EAE0E;EAC1E,uCAAuC;EACvC,+FAA+F;EAC/F,qCAAqC;;EAErC,UAAU;EACV,aAAa;EACb,cAAc;EACd,cAAc;;EAEd,kBAAkB;EAClB,WAAW;AACb;;AAEA;+EAC+E;AAC/E;EACE,oCAAoC;AACtC;;AAEA;;;;oEAIoE;AACpE;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B","sourcesContent":["/* ── Wirder design tokens ───────────────────────────────────────\n   Ported from the approved design system\n   (.github/style/design-system.md). Single brand palette applied at\n   :root. Imported globally from app.tsx. Fonts are loaded via a\n   <link> in public/index.html.\n   ────────────────────────────────────────────────────────────── */\n\n:root {\n  /* Primary (persimmon) */\n  --palette-primary: #c8400c;\n  --palette-primary-hover: #b23a0a;\n  --palette-primary-active: #9a3208;\n  --palette-on-primary: #ffffff;\n\n  /* Secondary (royal blue, from the logo) */\n  --palette-secondary: #0050c0;\n  --palette-secondary-hover: #00429f;\n  --palette-secondary-active: #003585;\n  --palette-on-secondary: #ffffff;\n\n  /* Accent (bright logo orange — decorative only, never text) */\n  --palette-accent: #f05000;\n  --palette-accent-soft: #fce6da;\n\n  /* Surfaces (warm paper) */\n  --palette-bg: #fbf7f0;\n  --palette-surface: #ffffff;\n  --palette-surface-alt: #f3ece0;\n  --palette-surface-blue-soft: #e7edfa;\n\n  /* Text (warm ink) */\n  --palette-text: #1c1b1a;\n  --palette-text-muted: #6b6357;\n\n  /* Borders */\n  --palette-border: #e4dccd;\n  --palette-border-strong: #1c1b1a;\n\n  /* Medal / rarity tiers (semantic, always paired with a label) */\n  --medal-gold: #c9a227;\n  --medal-silver: #9aa0a6;\n  --medal-bronze: #a9744f;\n\n  /* Type */\n  --font-display: \"Newsreader\", Georgia, \"Times New Roman\", serif;\n  --font-ui: \"Inter\", system-ui, -apple-system, \"Segoe UI\", sans-serif;\n\n  /* Play-surface (board) font — switchable on the Settings screen. The active\n     value is `--font-board`; it's remapped by the [data-board-font] attribute\n     that DataLayer sets on <html>. Defaults to the classic display serif. */\n  --font-board-serif: var(--font-display);\n  --font-board-sans: \"Calibri\", \"Inter\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  --font-board: var(--font-board-serif);\n\n  /* Radii */\n  --r-btn: 12px;\n  --r-tile: 12px;\n  --r-card: 16px;\n\n  /* Screen gutter */\n  --pad: 20px;\n}\n\n/* Board-font override: DataLayer sets data-board-font on <html> from the saved\n   preference (default is the serif above, so no attribute is needed for it). */\n:root[data-board-font=\"sans\"] {\n  --font-board: var(--font-board-sans);\n}\n\n/* Global text-size override: DataLayer sets data-text-size on <html> from the\n   saved preference. The app's text is sized in `rem`, so scaling the root\n   font-size proportionally enlarges every text element — including the smallest\n   labels (found-word chips, stat labels, captions). The board tiles are sized\n   in px/cqh, so they stay fixed while the surrounding text grows. */\n:root[data-text-size=\"default\"] {\n  font-size: 100%;\n}\n:root[data-text-size=\"large\"] {\n  font-size: 112.5%;\n}\n:root[data-text-size=\"larger\"] {\n  font-size: 125%;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-ui);\n  background: var(--palette-bg);\n  color: var(--palette-text);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Type helpers */\n.display {\n  font-family: var(--font-display);\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.02;\n}\n.serif {\n  font-family: var(--font-display);\n}\n.num {\n  font-variant-numeric: tabular-nums;\n  font-feature-settings: \"tnum\";\n}\n.muted {\n  color: var(--palette-text-muted);\n}\n.eyebrow {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--palette-text-muted);\n}\n.eyebrow--accent {\n  color: var(--palette-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
